import { Container, Grid, GridItem } from '@chakra-ui/react';

import { DestinationBox, Footer, HeroSection, StaysFilter, Visible } from 'components';
import { Heading } from 'elements';
import { HotelFilters } from 'hooks';
import { HERO_IMG_URL } from 'data';
import { useGetHotels } from 'hooks/hotels/use-get-hotels';
import { useHistory } from 'react-router-dom';
import { routes } from 'utils';

const Stays = () => {
  const { data } = useGetHotels();

  const history = useHistory();
  const onSearch = (filters: HotelFilters) => {};

  return (
    <Visible when={true}>
      {/** hero section */}
      <Container maxW='container.xl'>
        <HeroSection
          filter={<StaysFilter onChange={onSearch} />}
          heading='One place, for everything'
          bgImage={HERO_IMG_URL.stays}
        />
      </Container>
      {/** hero section */}

      <Container maxW='container.xl' padding='1.5rem 3rem'>
        <Heading />
      </Container>

      <Container maxW='container.xl'>
        <Grid templateColumns='repeat(auto-fit, minmax(250px, 1fr))' gap={6} justifyItems='center'>
          {data?.data?.map((hotel: any) => (
            <GridItem key={hotel.id} onClick={() => history.push({pathname: routes.STAYS.STAYS_RESULTS, state: {showActivities: false}},)}>
              <DestinationBox data={hotel} />
            </GridItem>
          ))}
        </Grid>
      </Container>

      <Footer />
    </Visible>
  );
};

export { Stays };
